import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRobot, faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp, faLinkedin, faFacebook, faTwitter, faYoutube } from '@fortawesome/free-brands-svg-icons';
import '../../styles/logistic/LogisticFooter.css';
import { useTranslation } from 'react-i18next';

const LogisticFooter: React.FC = () => {
  const { t } = useTranslation();
  return (
    <footer className="logistic-footer">
      <div className="logistic-container">
        <div className="logistic-footer-content">
          <div className="logistic-footer-brand">
            <div className="logistic-logo">
              <FontAwesomeIcon icon={faRobot} />
              <span>LogisticBot<span className="logistic-ai-badge">IA</span></span>
            </div>
            <p>{t('LogisticFooter:brand_description')}</p>
            <div className="logistic-footer-social">
              <a href="#"><FontAwesomeIcon icon={faLinkedin} /></a>
              <a href="#"><FontAwesomeIcon icon={faFacebook} /></a>
              <a href="#"><FontAwesomeIcon icon={faTwitter} /></a>
              <a href="#"><FontAwesomeIcon icon={faYoutube} /></a>
            </div>
          </div>

          <div className="logistic-footer-links">
            <h4>{t('LogisticFooter:product_title')}</h4>
            <ul>
              <li><a href="#beneficios">{t('LogisticFooter:product_link1')}</a></li>
              <li><a href="#como-funciona">{t('LogisticFooter:product_link2')}</a></li>
              <li><a href="#casos">{t('LogisticFooter:product_link3')}</a></li>
              <li><a href="#testimonios">{t('LogisticFooter:product_link4')}</a></li>
            </ul>
          </div>

          <div className="logistic-footer-links">
            <h4>{t('LogisticFooter:company_title')}</h4>
            <ul>
              <li><a href="#">{t('LogisticFooter:company_link1')}</a></li>
              <li><a href="#">{t('LogisticFooter:company_link2')}</a></li>
              <li><a href="#">{t('LogisticFooter:company_link3')}</a></li>
              <li><a href="#">{t('LogisticFooter:company_link4')}</a></li>
            </ul>
          </div>

          <div className="logistic-footer-contact">
            <h4>{t('LogisticFooter:contact_title')}</h4>
            <ul>
              <li><FontAwesomeIcon icon={faEnvelope} /> {t('LogisticFooter:contact_email')}</li>
              <li><FontAwesomeIcon icon={faPhone} /> {t('LogisticFooter:contact_phone')}</li>
              <li><FontAwesomeIcon icon={faWhatsapp} /> {t('LogisticFooter:contact_whatsapp')}</li>
            </ul>
          </div>
        </div>

        <div className="logistic-footer-bottom">
          <p>{t('LogisticFooter:copyright_prefix')} <span>{t('LogisticFooter:copyright_suffix')}</span></p>
          <div className="logistic-footer-legal">
            <a href="#">{t('LogisticFooter:legal_link1')}</a>
            <a href="#">{t('LogisticFooter:legal_link2')}</a>
            <a href="#">{t('LogisticFooter:legal_link3')}</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default LogisticFooter;
